// import { AgentInLenderContext } from '@nemuru-eng/js-api-client';
import { Agent, Channel, Currency, DownPayment, DownPaymentCollection } from '@nemuru-eng/js-api-client';

import { CartSummaryData } from '@/components/modules/_shared/CartSummary/types/CartSummaryData';
import { AutomobileDataEntity } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Automobile/entities/AutomobileDataEntity';
import { CartEntity } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/entities/CartEntity';
import { AbstractPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/AbstractPaymentMethod';
import { IberiaCardsStandsSelection } from '@/components/modules/Application/IberiaCards/_shared/types/IberiaCardsStandsSelection';
import { ShortContactFormType } from '@/components/modules/Application/IberiaCards/modules/ShortContactForm/schemas/ShortContactForm.schema';
import { CheckoutSessionCustomerData } from '@/components/modules/Application/types/CheckoutSessionCustomerData';
import { GenericApplicationStepValue } from '@/components/modules/Application/types/GenericApplicationStep';
import { CheckoutSessionDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/entities/CheckoutSessionDetailEntity';
import { MerchantInStructure } from '@/types/MerchantInStructure';

export const ApplicationContextInitialState = {
  // agent selection
  selectedAgent: undefined as Agent | undefined,
  selectedChannel: undefined as Channel | undefined,
  selectedMerchant: undefined as MerchantInStructure | undefined,
  selectedAgentHasError: undefined as boolean | undefined,

  // navigation
  step: undefined as GenericApplicationStepValue | undefined,
  steps: [] as GenericApplicationStepValue[],
  showSummary: true as boolean,

  // cart creation
  cart: undefined as CartEntity | undefined,
  isCartFormValid: false,
  doSubmitCart: false,
  orderReference1: undefined as undefined | string,
  orderReference2: undefined as undefined | string,
  automobileData: undefined as AutomobileDataEntity | undefined,
  customerData: undefined as CheckoutSessionCustomerData | undefined,
  birthDate: undefined as Date | undefined,

  checkoutSessionId: undefined as string | undefined,

  // iberia cards stands
  iberiaCardsStandsSelection: undefined as IberiaCardsStandsSelection | undefined,
  iberiaCardsStandsContact: undefined as ShortContactFormType | undefined,
  checkoutSessionEntity: undefined as CheckoutSessionDetailEntity | undefined,

  // down payment
  downPayment: {
    amount: {
      currency: Currency.EUR,
      amount: 0,
    },
    downPaymentCollection: DownPaymentCollection.NONE,
  } as DownPayment,

  // payment method
  paymentMethodEntities: undefined as AbstractPaymentMethod[] | undefined,

  // distribution
  hppId: undefined as string | undefined,
  qrCodeUrl: undefined as string | undefined,
  redirectUrl: undefined as string | undefined,
  hasActiveDistributionMethods: false as boolean,
  pollingCounter: 0 as number,

  // cart summary data
  cartSummaryData: undefined as CartSummaryData | undefined,
};
